import React, { forwardRef } from 'react'
import { useLoading, ThreeDots } from '@agney/react-loading'

const LoadingBounce = forwardRef((props, ref) => {
  const { containerProps, indicatorEl } = useLoading({
    loading: true,
    indicator: <ThreeDots width="50" />,
    loaderProps: {
      style: {
        color: '#737373'
      }
    }
  })

  return (
    <section ref={ref} {...containerProps}>
      {indicatorEl}
    </section>
  )
})

export default LoadingBounce
